import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=aab1a992&scoped=true"
import script from "./CourseVideo.vue?vue&type=script&lang=js"
export * from "./CourseVideo.vue?vue&type=script&lang=js"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=aab1a992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab1a992",
  null
  
)

export default component.exports